import { Theme } from '@eversports/react-components/design-tokens/theme'
import Card from '@eversports/react-components/primitives/Card'
import Flex from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { ShopProduct } from '../../../typings/Product'
import Venue from '../../../typings/Venue'
import BookingDetailsImage from '../common/BookingDetailsImage'
import ProductBookingDetailsContent from '../common/ProductBookingDetailsContent'

interface Props {
  product: ShopProduct
  venue: Venue
}

const useStyles = makeStyles((theme: Theme) => ({
  productInformation: {
    flex: '60%',
    padding: theme.layoutSpacing.wide,
  },
}))

const getBookingDetailsImage = (product: ShopProduct, venue: Venue) => {
  const voucherImage = (product.__typename === 'Voucher' && product.image && product.image.large) || undefined
  const recordingImage = (product.__typename === 'Recording' && product.image && product.image.large) || undefined
  const venueImage = (venue.images && venue.images[0] && venue.images[0].large) || undefined

  // return priority of existing images
  return voucherImage || recordingImage || venueImage
}

const DesktopProductBookingDetails: React.FC<React.PropsWithChildren<Props>> = ({ product, venue }) => {
  const classes = useStyles()
  const bookingDetailsImage = getBookingDetailsImage(product, venue)

  return (
    <Card raised>
      <Flex justifyContent="space-between">
        <div className={classes.productInformation}>
          <ProductBookingDetailsContent product={product} venue={venue} />
        </div>
        {bookingDetailsImage && <BookingDetailsImage src={bookingDetailsImage} />}
      </Flex>
    </Card>
  )
}

export default React.memo(DesktopProductBookingDetails)
